// extracted by mini-css-extract-plugin
export default {"review":"review_review__rjLtL","message":"review_message__6uprp","title":"review_title__uPD2E","readMore":"review_readMore__afdJw","author":"review_author__5HpLP"};